import React, { useEffect } from 'react'
import { Container, NavLink } from './Styles'

export const Congrats = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <div>
        <Container>
            <div>
                <img src="img/Emoji (1).svg" alt="" />
            </div>
            <h3>Congratulations!!!</h3>
            <p>You have been successfully registered on Bonpellz</p>
            <p>Anticipate the finest journey to your financial freedom</p>
            <NavLink to="/">
                    Go back to Homepage
            </NavLink>
            
        </Container>

    </div>
  )
}
